import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateAllowedDomainRPC } from "./updateAllowedDomainRPC";

export class UpdateAllowedDomainRPCClientImpl extends UpdateAllowedDomainRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateAllowedDomainRPC.Request): Promise<LeoRPCResult<UpdateAllowedDomainRPC.Response, UpdateAllowedDomainRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/UpdateAllowedDomain",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateAllowedDomainRPC.ResponseDTO,
      UpdateAllowedDomainRPC.Errors.ErrorsDTO,
      UpdateAllowedDomainRPC.Response,
      UpdateAllowedDomainRPC.Errors.Errors
    >(
      response,
      "email-cycle/UpdateAllowedDomain",
      UpdateAllowedDomainRPC.Response.fromDTO,
      UpdateAllowedDomainRPC.Errors.fromDTO
    );
  }
}
